export default __webpack_public_path__ + "static/media/diamond-shine.061ca9ce.svg";